import { defineMessages } from 'react-intl';

const scope = 'dashboard.writing';

const messages = defineMessages({
  addAnswerAreaPaperLabel: {
    id: `${scope}.AddAnswerAreaPaper.Label`,
    defaultMessage: '영역 길이:',
  },
  addAnswerAreaPaperButtonNext: {
    id: `${scope}.AddAnswerAreaPaper.Button.next`,
    defaultMessage: '다음',
  },
  addAnswerAreaPaperButtonPrev: {
    id: `${scope}.AddAnswerAreaPaper.Button.prev`,
    defaultMessage: '이전',
  },
  addAnswerAreaPaperInstruction: {
    id: `${scope}.AddAnswerAreaPaper.Instruction`,
    defaultMessage: 'PDF 영역에서 답변 위치를 지정해주세요.',
  },
  addAnswerAreaPaperNumber: {
    id: `${scope}.AddAnswerAreaPaper.Number`,
    defaultMessage: 'Q{ number }',
  },
  addAnswerAreaPaperTypeDescriptive: {
    id: `${scope}.AddAnswerAreaPaper.Type.DESCRIPTIVE`,
    defaultMessage: '단답∙서술형',
  },
  addOptionPaperButtonNext: {
    id: `${scope}.AddOptionPaper.Button.next`,
    defaultMessage: '다음',
  },
  addOptionPaperButtonPrev: {
    id: `${scope}.AddOptionPaper.Button.prev`,
    defaultMessage: '이전',
  },
  addOptionPaperHelperText: {
    id: `${scope}.AddOptionPaper.HelperText`,
    defaultMessage: '{ count }개의 선택지',
  },
  addOptionPaperInstruction: {
    id: `${scope}.AddOptionPaper.Instruction`,
    defaultMessage: 'PDF 영역에서 선택지 위치를 지정해주세요.',
  },
  addOptionPaperNumber: {
    id: `${scope}.AddOptionPaper.Number`,
    defaultMessage: 'Q{ number }',
  },
  addOptionPaperTypeMultipleSelection: {
    id: `${scope}.AddOptionPaper.Type.MULTIPLE_SELECTION`,
    defaultMessage: '복수선택형',
  },
  addOptionPaperTypeSingleSelection: {
    id: `${scope}.AddOptionPaper.Type.SINGLE_SELECTION`,
    defaultMessage: '단일선택형',
  },
  addOptionPaperUndoButton: {
    id: `${scope}.AddOptionPaper.UndoButton`,
    defaultMessage: '지정 취소',
  },
  addQuestionPaperInstruction: {
    id: `${scope}.AddQuestionPaper.Instruction`,
    defaultMessage: 'PDF 영역에서 질문 영역을 지정해주세요.',
  },
  addQuestionPaperButtonNext: {
    id: `${scope}.AddQuestionPaper.Button.next`,
    defaultMessage: '다음',
  },
  addQuestionPaperButtonPrev: {
    id: `${scope}.AddQuestionPaper.Button.prev`,
    defaultMessage: '이전',
  },
  addQuestionPaperNumber: {
    id: `${scope}.AddQuestionPaper.Number`,
    defaultMessage: 'Q{ number }',
  },
  addQuestionPaperTypeDescriptive: {
    id: `${scope}.AddQuestionPaper.Type.DESCRIPTIVE`,
    defaultMessage: '단답∙서술형',
  },
  addQuestionPaperTypeMultipleSelection: {
    id: `${scope}.AddQuestionPaper.Type.MULTIPLE_SELECTION`,
    defaultMessage: '복수선택형',
  },
  addQuestionPaperTypeSingleSelection: {
    id: `${scope}.AddQuestionPaper.Type.SINGLE_SELECTION`,
    defaultMessage: '단일선택형',
  },
  addSignaturePaperButtonNext: {
    id: `${scope}.AddSignaturePaper.Button.finish`,
    defaultMessage: '완료',
  },
  addSignaturePaperButtonPrev: {
    id: `${scope}.AddSignaturePaper.Button.prev`,
    defaultMessage: '이전',
  },
  addSignaturePaperInstruction: {
    id: `${scope}.AddSignaturePaper.Instruction`,
    defaultMessage: 'PDF 영역에서 서명받을 위치를 지정해주세요.',
  },
  addSignaturePaperNumber: {
    id: `${scope}.AddSignaturePaper.Number`,
    defaultMessage: 'S{ number }',
  },
  addSignaturePaperType: {
    id: `${scope}.AddSignaturePaper.Type`,
    defaultMessage: '전자 서명',
  },
  descriptionFieldLabel: {
    id: `${scope}.DescriptionField.Label`,
    defaultMessage: '설명',
  },
  descriptionFieldPlaceholder: {
    id: `${scope}.DescriptionField.TextField.placeholder`,
    defaultMessage: '가정통신문에 대한 설명을 입력해주세요',
  },
  fileFieldButtonFileChange: {
    id: `${scope}.FileField.Button.fileChange`,
    defaultMessage: '파일 교체',
  },
  fileFieldFilezone: {
    id: `${scope}.FileField.Filezone`,
    defaultMessage: '불러오기',
  },
  fileFieldHelperText: {
    id: `${scope}.FileField.HelperText`,
    defaultMessage: 'PDF 파일 1개 첨부 가능',
  },
  fileFieldTooltip: {
    id: `${scope}.FileField.Tooltip`,
    defaultMessage: '문항이 모두 삭제되고 새로운 pdf로 교체됩니다',
  },
  fileFieldLabel: {
    id: `${scope}.FileField.Label`,
    defaultMessage: '파일 첨부',
  },
  formActionsButtonSave: {
    id: `${scope}.FormActions.Button.save`,
    defaultMessage: '임시저장',
  },
  formActionsButtonSend: {
    id: `${scope}.FormActions.Button.send`,
    defaultMessage: '전송하기',
  },
  numberFieldLabel: {
    id: `${scope}.NumberField.Label`,
    defaultMessage: '번호',
  },
  numberFieldNumberSuffix: {
    id: `${scope}.NumberField.numberSuffix`,
    defaultMessage: '제',
  },
  numberFieldOrdinal: {
    id: `${scope}.NumberField.ordinal`,
    defaultMessage: '호',
  },
  pdfViewerCanvas: {
    id: `${scope}.PDFViewer.Canvas`,
    defaultMessage:
      '현재 사용 중인 브라우저에서 지원하지 않는 기능입니다. 다른 브라우저를 이용해주세요.',
  },
  pdfViewerPageNumber: {
    id: `${scope}.PDFViewer.PageNumber`,
    defaultMessage: '{ page }페이지',
  },
  pdfViewerVisibilityToggleButtonVisible: {
    id: `${scope}.PDFViewer.VisibilityToggleButton.visible`,
    defaultMessage: '문항 표시',
  },
  pdfViewerVisibilityToggleButtonInvisible: {
    id: `${scope}.PDFViewer.VisibilityToggleButton.invisible`,
    defaultMessage: '문항 숨김',
  },
  questionRendererFieldRect: {
    id: `${scope}.QuestionRenderer.FieldRect`,
    defaultMessage: '{ number }번 질문 답변',
  },
  reservationFieldLabel: {
    id: `${scope}.ReservationField.Label`,
    defaultMessage: '전송 시간',
  },
  reservationFieldRadioNow: {
    id: `${scope}.ReservationField.Radio.now`,
    defaultMessage: '현재',
  },
  reservationFieldRadioReservation: {
    id: `${scope}.ReservationField.Radio.reservation`,
    defaultMessage: '예약',
  },
  reservationFieldRadioGroupAriaLabel: {
    id: `${scope}.ReservationField.RadioGroup.ariaLabel`,
    defaultMessage: '전송 시간',
  },
  reservationFieldHelperText: {
    id: `${scope}.ReservationField.HelperText`,
    defaultMessage: '설정한 시간으로 예약 전송됩니다.',
  },
  selectRequiredPaperButtonPrev: {
    id: `${scope}.SelectRequiredPaper.Button.prev`,
    defaultMessage: '이전',
  },
  selectRequiredPaperButtonFinish: {
    id: `${scope}.SelectRequiredPaper.Button.finish`,
    defaultMessage: '완료',
  },
  selectRequiredPaperInstruction: {
    id: `${scope}.SelectRequiredPaper.Instruction`,
    defaultMessage: '응답 필수 여부를 선택해주세요.',
  },
  selectRequiredPaperNumber: {
    id: `${scope}.SelectRequiredPaper.Number`,
    defaultMessage: 'Q{ number }',
  },
  selectRequiredPaperOptionCount: {
    id: `${scope}.SelectRequiredPaper.OptionCount`,
    defaultMessage: '선택지 { count }개',
  },
  selectRequiredPaperRadioUnrequired: {
    id: `${scope}.SelectRequiredPaper.Radio.unrequired`,
    defaultMessage: '선택',
  },
  selectRequiredPaperRadioRequired: {
    id: `${scope}.SelectRequiredPaper.Radio.required`,
    defaultMessage: '필수',
  },
  selectRequiredPaperRadioGroupAriaLabel: {
    id: `${scope}.SelectRequiredPaper.RadioGroup.ariaLabel`,
    defaultMessage: '응답 필수 여부',
  },
  selectRequiredPaperTypeDescriptive: {
    id: `${scope}.SelectRequiredPaper.Type.DESCRIPTIVE`,
    defaultMessage: '단답∙서술형',
  },
  selectRequiredPaperTypeMultipleSelection: {
    id: `${scope}.SelectRequiredPaper.Type.MULTIPLE_SELECTION`,
    defaultMessage: '복수선택형',
  },
  selectRequiredPaperTypeSingleSelection: {
    id: `${scope}.SelectRequiredPaper.Type.SINGLE_SELECTION`,
    defaultMessage: '단일선택형',
  },
  selectTypePaperButtonSingleSelection: {
    id: `${scope}.SelectTypePaper.Button.SINGLE_SELECTION`,
    defaultMessage: '단일선택형',
  },
  selectTypePaperButtonMultipleSelection: {
    id: `${scope}.SelectTypePaper.Button.MULTIPLE_SELECTION`,
    defaultMessage: '복수선택형',
  },
  selectTypePaperButtonDescriptive: {
    id: `${scope}.SelectTypePaper.Button.DESCRIPTIVE`,
    defaultMessage: '단답∙서술형',
  },
  selectTypePaperButtonSignature: {
    id: `${scope}.SelectTypePaper.Button.SIGNATURE`,
    defaultMessage: '전자서명',
  },
  selectTypePaperHelperText: {
    id: `${scope}.SelectTypePaper.HelperText`,
    defaultMessage: '가정통신문에 추가할 문항 유형을 선택해주세요.',
  },
  selectTypePaperNote: {
    id: `${scope}.SelectTypePaper.Note`,
    defaultMessage: '학년, 반, 이름은 문항으로 추가하지 않아도, 서비스 안에서 자동으로 입력됩니다.',
  },
  signatureCursorFollower: {
    id: `${scope}.SignatureCursorFollower`,
    defaultMessage: '전자 서명',
  },
  signatureRendererSignature: {
    id: `${scope}.SignatureRenderer.Signature`,
    defaultMessage: '전자 서명',
  },
  stepGuideButtonActive: {
    id: `${scope}.StepGuide.StepGuideButton.active`,
    defaultMessage: '닫기',
  },
  stepGuideButtonInactive: {
    id: `${scope}.StepGuide.StepGuideButton.inactive`,
    defaultMessage: '문항 만들기',
  },
  targetFieldButton: {
    id: `${scope}.TargetField.Button`,
    defaultMessage: '선택하기',
  },
  targetFieldLabel: {
    id: `${scope}.TargetField.Label`,
    defaultMessage: '전송 대상',
  },
  titleFieldLabel: {
    id: `${scope}.TitleField.Label`,
    defaultMessage: '제목',
  },
  titleFieldPlaceholder: {
    id: `${scope}.TitleField.TextField.placeholder`,
    defaultMessage: '가정통신문의 제목을 입력해주세요',
  },
  writingHeading: {
    id: `${scope}.Writing.Heading`,
    defaultMessage: '가정통신문 작성',
  },
  writingOutboxButton: {
    id: `${scope}.Writing.Link`,
    defaultMessage: '임시보관함',
  },
});

export default messages;
